import type { ErrorMessage } from 'src/types';

export enum GraphQLErrorCode {
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  BAD_USER_INPUT = 'BAD_USER_INPUT',
}

export interface I18nErrorPath {
  field: string;
  path: string;
}

export interface DetailedI18nError {
  message: ErrorMessage;
  code: string;
  reason: string;
  path: I18nErrorPath;
}

export interface I18nAccountError {
  __typename: string;

  message: ErrorMessage;
  code: string;
  reason: string;
  details: DetailedI18nError[];
}
export interface ChangeEmailAddressSuccess {
  __typename: string;
  ref: string;
}

export interface ChangeEmailAddressFailure {
  __typename: string;
  error: I18nAccountError;
}

export interface ChangePasswordSuccess {
  __typename: string;
  ref: string;
}

export interface ChangePasswordFailure {
  __typename: string;
  error: I18nAccountError;
}

export interface DeleteAccountSuccess {
  __typename: string;
  ref: string;
}

export interface DeleteAccountFailure {
  __typename: string;
  error: I18nAccountError;
}

export interface PasswordInput {
  password: string;
}

export class AuthenticationError extends Error {
  name = 'AuthenticationError';

  constructor() {
    super();
  }
}
